<template lang="pug">
router-view(v-if='accepted')
div(v-else)
  div(class="ag-container")
    h3(class="title") Безусловным акцептом Соглашения является совокупность следующих действий:
    ul(class="mt-4")
      li регистрация Партнера в личном кабинете мобильного приложения «Унистрой»;
      li принятие условий <a href="https://uos.unistroyrf.ru/loyalty_partners/pub_offer.pdf" target="_blank">«публичной оферты»</a>;
      li предоставление <a href="https://uos.unistroyrf.ru/loyalty_partners/agreement_mob.pdf" target="_blank">«согласия на обработку персональных данных»</a>, <a href="https://uos.unistroyrf.ru/loyalty_partners/agreement_mob_share.pdf" target="_blank">«согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения»</a> (для индивидуальных предпринимателей и физических лиц).
    v-divider(class='my-4')
    v-btn(
      @click='accept'
      color='primary'
      :loading='loading'
      depressed
    )
      span Принять Cоглашение
</template>

<script>
import { userRoles } from '@/enums/user-roles'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    accepted: true,
    loading: false
  }),
  mounted() {
    // чекаем только роль партнера лояльного
    const uRoleCode = userRoles.LoyaltyPartner
    if (this.$user.hasRoles([uRoleCode])) {
      const uRole = this.$user.getUserRoleByCode(uRoleCode)
      if (uRole !== undefined) {
        // принял некое соглашение
        this.accepted = !uRole.agreement_required
      }
    }
  },
  methods: {
    async accept() {
      try {
        this.loading = true
        await this.agreeToOffer(userRoles.LoyaltyPartner)
        window.location.reload()
      } catch (error) {
        this.$root.showSnack('Произошла непредвиденная ошибка')
      } finally {
        this.loading = false
      }
    },
    ...mapActions('auth', ['agreeToOffer'])
  }
}
</script>

<style scoped>
.ag-container {
  max-width: 600px;
  font-size: 16px;
  line-height: 1.5;
}
</style>